export const getEndpointFromConfig = async serviceId => undefined;